import React from 'react';

import Pocket from '../../../components/DataTable/PocketDataTable';

const TYPE_MAP = {
    popular: 'popular_games',
    best: 'best_games',
};

export default function GamesVKP({ type }) {
    return (
        <Pocket
            itemsLimit={130}
            type={TYPE_MAP[type]}
            project="media.vkplay.ru"
            requiredFields={[]}
            columnsArray={[
                {
                    type: 'title',
                    accessor: 'entity.name',
                },
                { type: 'delete' },
            ]}
            formFields={[
                {
                    type: 'gameSearch',
                    name: 'gameSearch',
                },
            ]}
        />
    );
}
